import PieveSymbol from '../../../../components/surfaces/PieveSymbol.jsx';
import PieveWordmark from '../../../../components/surfaces/PieveWordmark.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';

const SWATCHES = [
  { token: '--color-bg', name: 'Page' },
  { token: '--color-surface', name: 'Surface' },
  { token: '--color-surface-selected', name: 'Selected' },
  { token: '--color-border', name: 'Divider' },
  { token: '--color-border-strong', name: 'Control edge' },
  { token: '--color-text', name: 'Text' },
  { token: '--color-text-secondary', name: 'Secondary text' },
  { token: '--color-brand', name: 'Brand' },
  { token: '--color-accent', name: 'Signature' },
  { token: '--color-success', name: 'Success' },
  { token: '--color-warning', name: 'Warning' },
  { token: '--color-danger', name: 'Danger' },
  { token: '--color-info', name: 'Info' }
];

const TYPE_SAMPLES = [
  { className: 'gallery-type--heading-xl', spec: 'Manrope 600, 36/44', text: 'Work, handled.' },
  { className: 'gallery-type--heading-lg', spec: 'Manrope 600, 28/36', text: 'Weekly invoice follow-up' },
  { className: 'gallery-type--heading-md', spec: 'Manrope 600, 22/28', text: 'Connections' },
  { className: 'gallery-type--heading-sm', spec: 'Manrope 600, 18/24', text: 'Runs this week' },
  { className: 'gallery-type--body-lg', spec: 'Inter 400, 16/24', text: 'Pieve checks unpaid invoices every Monday and drafts a reminder for each customer.' },
  { className: 'gallery-type--body', spec: 'Inter 400, 14/20', text: 'Uses your QuickBooks and Gmail connections. Nothing is sent without your approval.' },
  { className: 'gallery-type--small', spec: 'Inter 400, 13/18', text: 'Last run 12 minutes ago' },
  { className: 'gallery-type--mono', spec: 'IBM Plex Mono 400, 13/18', text: 'invoices.list(status: "overdue")' }
];

const BrandSection = () => {
  return (
    <GallerySection id="brand" title="Brand and foundations" description="Deep Teal sets the identity, neutrals carry the interface, coral appears only as a signature detail.">
      <GalleryExample label="Logo">
        <div className="gallery-logo-tile">
          <PieveWordmark height={40} />
        </div>
        <div className="gallery-logo-tile">
          <PieveSymbol size={48} />
        </div>
        <div className="gallery-logo-tile gallery-logo-tile--brand">
          <PieveSymbol size={48} />
        </div>
      </GalleryExample>
      <GalleryExample label="Color tokens in this theme">
        <ul className="gallery-swatches">
          {SWATCHES.map((swatch) => (
            <li key={swatch.token} className="gallery-swatch">
              <span className="gallery-swatch__chip" style={{ background: `var(${swatch.token})` }} />
              <span className="gallery-swatch__name">{swatch.name}</span>
              <code className="gallery-swatch__token">{swatch.token}</code>
            </li>
          ))}
        </ul>
      </GalleryExample>
      <GalleryExample label="Type scale" stacked>
        {TYPE_SAMPLES.map((sample) => (
          <div key={sample.spec} className="gallery-type-row">
            <span className="gallery-type-row__spec">{sample.spec}</span>
            <span className={`gallery-type ${sample.className}`}>{sample.text}</span>
          </div>
        ))}
      </GalleryExample>
    </GallerySection>
  );
};

export default BrandSection;
